<template>
  
  <div :class="`board board-${type} ${folded?'folded':initState}`">
    <!-- <div class="header">
      <img v-if="type" :src="`head/title-${type}.svg`|img">
    </div> -->
    <template v-if="type=='college'||type=='organization'||type=='teacher'">
      <div class="list clear">
        <p v-for="item in table.slice(0, folded?undefined:(3*(global.pc?2:1)*(type=='teacher'?2:1)))" :key="item">{{item}}</p>
      </div>
      <div class="fold">
        <span v-show="!folded" @click="fold">展开更多<img :src="'fold.svg'|img"></span>
      </div>
    </template>
    <template v-else-if="type=='industry'">
      <small>汉仪字库为了让字体行业走向公众视野，走向公众文化，拥有更加广泛的社会认知。从汉仪第四届字体之星大赛开始，增加汉仪字库行业特别贡献奖，用以鼓励为推动社会大众对字体设计乃至行业作出杰出贡献的个人。</small>
      <table v-if="table">
        <tr>
          <th class="name">姓名</th>
          <th class="project">项目</th>
          <!-- <th class="recommender">推荐人</th> -->
        </tr>
        <tr v-for="item in table" :key="item.name+item.project">
          <td class="name" v-html="item.name"></td>
          <td class="project" v-html="td_format(item.project)"></td>
          <!-- <td class="recommender" v-html="td_format(item.recommender)"></td> -->
        </tr>
      </table>
    </template>
    <template v-else>
      <div class="tabs clear">
        <span v-for="item in tab.items" :class="item.key==tab.selected&&'active'" :key="item.key" @click="tabChange(item)">{{item.label}}</span>
      </div>
      <template v-if="type=='final'">
        <small>点击下方作品查看详情<img :src="'touch-detail.svg'|img"></small>
        <div class="prizes clear">
          <template v-for="(item,i) in table[tab.selected]" >
            <div class="hr" v-if="item.prize=='j'&&table[tab.selected][i-1].prize=='3'">
              <img :src="'board/title-prize-judge.svg'|img"/>
            </div>
            <div class="prize" :key="item.prize+item.sn">
              <div :class="`prize-${item.prize}`">
                <div class="pic">
                  <img class="works"  @click="showWorks(item)" :src="`works/${item.sn}.png?v2`|img"/>
                  <img :src="`board/prize-${item.prize}.svg`|img"/>
                </div>
                <h5>{{item.works}}</h5>
                <p><i>作者名称：</i>{{item.author}}</p>
                <p v-if="item.teacher"><i>指导老师：</i>{{item.teacher}}</p>
                <p v-if="item.prize=='j'&&item.judges[0]"><i>评奖评委：</i>{{item.judges[0].judge}}</p>
                <p v-if="!item.teacher&&item.works.length<18"></p>
              </div>
            </div>
          </template>
        </div>
        <div v-if="works.show" class="works-pop">
          <a v-if="works.left" class="left" @click="showWorks(works.left)"><img :src="'works/left.svg'|img-pc"></a>
          <a v-if="works.right" class="right" @click="showWorks(works.right)"><img :src="'works/right.svg'|img-pc"></a>
        </div>
        <van-popup v-model="works.show" class="works-pop">
          <div class="content" v-if="works.show">
            <div class="head">
              <img class="back" :src="'works/head.svg'|img-pc">
              <img class="title" :src="`works/prize-title-${works.prize}.svg`|img"/>
              <p>{{works.works}}</p>
            </div>
            <div class="info">
              <p><i v-html="'组&emsp;&emsp;别'"></i>{{works.group}}</p>
              <p><i>作者名称</i>{{works.author}}</p>
              <p v-if="works.teacher"><i>指导老师</i>{{works.teacher}}</p>
              <p v-if="works.prize=='j'&&works.judges[0]"><i>评奖评委</i>{{works.judges[0].name}}</p>
            </div>
            <!-- <div class="judge">
              <img class="title" :src="'works/title-judge.svg'|img"/>
              <div class="item" v-for="item in works.judges">
                <img :src="`judge/judges_${item.key}.png`|img-pc">
                <h6>{{item.name}}</h6>
                <p v-html="item.desc"></p>
                <div class="">
                  {{item.text}}
                </div>
              </div>
            </div> -->
            <div class="works">
              <img class="title" :src="'works/title-works.svg'|img"/>
              <img class="pic" :src="`works/${works.sn}.png`|img"/>
            </div>
          </div>
        </van-popup>
      </template>
      <template v-else>
        <table v-if="table[tab.selected]">
          <tr>
            <th v-if="tab.selected === 'en'" class="group">作品组别</th>
            <th class="work">作品名称</th>
            <th class="author">作者</th>
            <!-- <th class="teacher">指导老师</th> -->
          </tr>
          <tr v-for="item in table[tab.selected].slice(0, folded?undefined:(initState=='mini'?2:5))" :key="item.sn">
            <td v-if="tab.selected === 'en'" class="group">{{ item.group || '—' }}</td>
            <td class="work">{{item.works}}</td>
            <td class="author" v-html="td_format(item.author)"></td>
            <!-- <td class="teacher" v-html="td_format(item.teacher)||'&emsp;—&emsp;'"></td> -->
          </tr>
        </table>
        <div class="fold">
          <span v-show="!folded" @click="fold">展开更多<img :src="'fold.svg'|img"></span>
        </div>
      </template>
      <a v-if="!global.pc" class="generate" @click="generate">点击生成获奖证书</a>
    </template>
    <p v-if="tip" class="tip"><img :src="'info.svg'|img">{{tip}}</p>
  </div>
</template>

<script>
export default {
  name: 'Board',
  props: {
    'table': {
      type: [Object,Array],
      default: null,
    },
    'type': String,
    'tip': String,
    'init-state': String,
    'judges': Array,
  },
  data(){
    // console.log(this.table);
    return {
      folded: !this.initState,
      tab: {
        items: [
          {key:'cn-stu', label: '中文学生组'},
          {key:'cn-pro', label: '中文专业组'},
          {key:'en', label: '多文种'},
        ],
        selected: 'cn-stu',
      },
      works: {
        show: false,
      },
    };
  },
  methods:{
    td_format(txt){
      txt = (txt||'').split('、');
      return txt.map(item=>{
        if(item.length==2){
          return item[0]+'&emsp;'+item[1];
        }
        return item;
      }).join('<br/>');
    },
    tabChange(item){
      this.tab.selected = item.key;
    },
    fold(){
      this.folded = true;
    },
    generate(){
      let tab = this.tab.selected,
        type = this.type,
        items = this.table[tab];
      this.$emit('generate', {items, type, key: type+'/'+tab});
    },
    showWorks(item){
      let items = this.table[this.tab.selected],
        index = _.findIndex(items, item);
      this.works = _.extend({}, item, {
        show: true,
        left: items[index-1],
        right: items[index+1],
        group: _.find(this.tab.items, {key: this.tab.selected}).label,
        judges: _.map(item.judges, item=>{
          return _.extend({text: item.text.trim()}, _.find(this.judges, {name: item.judge}))
        })
      });
    },
  }
}
</script>

<style lang="less">
.board{
  background: #000000;
  border-radius: 0 0 8px 8px;
  margin: 30px 16px;
  max-width: 100%;
  overflow: hidden;
  font-size: 12px;
  position: relative;
  
  .header{
    height: 48px;
    padding: 13px;
    text-align: center;
    background-image: url('~@/assets/head/title-back-f.png');
    background-size: 100% 100%;
  }
  .header img{
    height: 24px;
    width: auto;
  }
  .tabs{
    border-radius: 23px;
    margin: 16px;
    height: 28px;
    background: #E8C990;
    overflow: hidden;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      height: 16px;
      background: #E8C990;
      z-index: -1;
    } 
    span{
      display: block;
      line-height: 28px;
      height: 28px;
      float: left;
      width: 33.33%;
      font-weight: 600;
      font-size: 12px;
      background: #E8C990;
      color: #000;
      cursor: pointer;
      transition: all 0.3s ease;
      &:first-child{
        border-radius: 23px 0 0 23px;
      }
      &:last-child{
        border-radius: 0 23px 23px 0;
      }
      &.active{
        background: #B3854A;
        color: #fff;
        border-radius: 23px !important;
      }
    }
  }
  table{
    width: 100%;
    text-align: center;
    border-collapse:collapse;
    transition: all ease .3s;
    background: #000;
    td,th{
      vertical-align: middle;
      padding: 8px 16px;
      line-height: 20px;
      border-bottom: 1px solid #E8C990;
      border-right: 1px solid #E8C990;
      text-align: center;
      &:last-child{
        border-right: none;
      }
      &.work{
        width: auto;
        padding-left: 16px;
        padding-right: 16px;
      }
      &.author{
        width: 22%;
        white-space: nowrap;
        padding-left: 16px;
        padding-right: 16px;
      }
      &.group{
        width: 25%;
        white-space: nowrap;
        padding-left: 16px;
        padding-right: 16px;
      }
    }
    th{
      line-height: 12px;
      font-weight: bold;
      background: #E8C990 !important;
      color: #000 !important;
    }
    td{
      color: #fff !important;
      background: #000 !important;
    }
    tr{
      color: #fff;
    }
  }
  .fold{
    margin: 9px 0 32px;
    cursor: pointer;
    img{
      width: 10px;
      position: relative;
      top: -1px;
      left: 3px;
    }
  }
  .generate{
    display: block;
    line-height: 40px;
    margin: 0 16px;
    border-radius: 27px;
    font-weight: 500;
    font-size: 16px;
    color: #000;
    background: #E3CA96;
  }
  .list{
    margin: 48px 0 30px;
    border-top: 1px solid #F1F1F4;
    p{
      margin: 0;
      border-bottom: 1px solid #F1F1F4;
      font-size: 14px;
      color: #3B1D0C;
      opacity: 0.65;
      line-height: 36px;
      &:nth-child(odd){
        background: #FEFDFC;
      }
    }
    &~.tip{
      position: absolute;
      width: 100%;
      text-align: center;
      top: 64px;
      margin: 0;
    }
  }
  .tip{
    margin: 16px 0 22px;
    text-align: justify;
    padding: 0 16px;
    opacity: 0.65;
    img {
      width: 12px;
      position: relative;
      top: 1px;
      margin-right: 4px;
    }
  }
  
  .prizes{
    margin: 0 11px 16px;
    .hr{
      width: 100%;
      position: relative;
      float: left;
      margin: 16px 0 32px;
      img{
        height: 16px;
      }
      &:before, &:after{
        position: absolute;
        top: 50%;
        display: block;
        content: ' ';
        height: 1px;
        width: 108px;
      }
      &:before{
        left: 0;
        background: linear-gradient(270deg, #EA6B55 0%, rgba(234, 107, 85, 0) 100%);
      }
      &:after{
        right: 0;
        background: linear-gradient(90deg, #EA6B55 0%, rgba(234, 107, 85, 0) 100%);
      }
    }
  }
  .prize{
    float: left;
    padding: 0 5px 16px;
    width: 50%;
    text-align: left;
    color: #666666;
    .pic{
      margin: 0 0 4px;
      img{
        display: block;
        width: 100%;
      }
    }
    .works{
      border: 1px solid #000;
      border-bottom: none;
    }
    h5{
      word-break: break-all;
      font-size: 14px;
      line-height: 22px;
    }
    p{
      font-size: 12px;
      line-height: 22px;
      min-height: 22px;
      position: relative;
      padding-left: 60px;
    }
    i{
      position: absolute;
      left: 0;
      top: 0;
      font-style: normal;
    }
  }
  .prize-1{
    .works{
      border-color: #F2D954;
    }
  }
  .prize-2{
    .works{
      border-color: #CFC8C5;
    }
  }
  .prize-3{
    .works{
      border-color: #D3B49B;
    }
  }
  .prize-j{
    .works{
      border-color: #F67B65;
    }
  }
  
  .works-pop{
    background: none;
    padding: 30px 0;
    .left,.right{
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10001;
    }
    .left{
      left: 24px;
    }
    .right{
      right: 24px;
    }
    .content{
      background: #fff;
      width: 300px;
      border-radius: 6px;
    }
    .head{
      height: 64px;
      background-size: cover;
      font-size: 14px;
      color: #ED930B;
      margin: 0 0 20px;
      padding: 8px 0 0;
      position: relative;
      .back{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
      .title{
        height: 22px;
        margin: 0 0 4px;
      }
    }
    .info{
      font-size: 14px;
      color: #333333;
      width: 156px;
      margin: 0 auto;
      text-align: left;
      white-space: nowrap;
      p{
        margin: 0 0 6px;
        width: 186px;
        white-space: normal;
        position: relative;
        padding-left: 72px;
        line-height: 20px;
      }
      i{
        position: absolute;
        left: 0;
        top: 0;
        font-style: normal;
        color: #999999;
      }
    }
    .judge{
      .item{
        margin: 28px 16px 24px;
        text-align: left;
        img{
          width: 64px;
          display: block;
          margin: 0 auto 8px;
        }
        h6{
          font-size: 14px;
          font-weight: 500;
          margin: 0 0 4px;
          text-align: center;
        }
        p{
          color: #666666;
          line-height: 20px;
          text-align: center;
        }
        div{
          margin: 26px 0 0;
          background: #FCFCFC;
          border: 1px solid #F2F2F2;
          box-sizing: border-box;
          border-radius: 2px;
          font-size: 14px;
          padding: 8px 16px 12px;
          text-align: justify;
        }
      }
    }
    .title{
      height: 22px;
      margin: 24px auto 20px;
      display: block;
    }
    .pic{
      margin: 0 0 20px;
    }
  }

  &.brown{
    .tabs{
      span{
        background: #E8C990;
        color: #000;
      }
      .active{
        background: #B3854A;
        color: #fff;
      }
    }
    tr{
      color: #3B1D0C;
    }
    th{
      background: #F4F3F1;
      color: #5B280B;
    }
    .fold{
      color: #927A69;
    }
    .generate{
      background: #E3CA96;
    }
    .tip{
      color: #5B280B;
    }
  }
  &.grey{
    .tabs{
      span{
        background: #E8C990;
        color: #000;
      }
      .active{
        background: #B3854A;
        color: #fff;
      }
    }
    tr{
      color: #666666;
    }
    th{
      background: #F1F1F4;
      color: #333333;
    }
    .fold{
      color: #666666;
    }
    .generate{
      background: #E3CA96;
    }
    .tip{
      color: #9B9B9B;
    }
  }
  &.gold{
    .tabs{
      span{
        background: #E8C990;
        color: #000;
      }
      .active{
        background: #B3854A;
        color: #fff;
      }
    }
    tr{
      color: #3B1D0C;
      opacity: 0.65;
    }
    th{
      background: #F4F3F1;
      color: #5B280B;
    }
    .generate{
      background: #E3CA96;
      margin-bottom: 28px;
    }
    .tip{
      color: #3B1D0C;
    }
  }
  &.board-industry{
    text-align: left;
    padding-bottom: 30px;
    small{
      font-size: 12px;
      line-height: 18px;
      text-align: justify;
      color: #3B1D0C;
      opacity: 0.45;
      margin: 16px;
      display: block;
    }
    td,th{
      width: 40%;
      &:first-child{
        width: 30%;
      }
      &:last-child{
        width: 30%;
      }
    }
  }
  &.board-final{
    padding-bottom: 20px;
    small{
      font-size: 12px;
      color: #5B280B;
      opacity: 0.65;
      margin: 16px;
      display: block;
      img{
        width: 14px;
        position: relative;
        top: 3px;
      }
    }
  }

  &.mini{
    position: relative;
    padding-bottom: 40px;
    .tip,.generate{
      display: none;
    }
    &.board-college,&.board-teacher{
      .tip{
        display: block;
      }
    }
    .fold{
      font-size: 14px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 80%, #000000 100%);
      padding: 76px 0 20px;
      margin: 0;
      border-radius: 8px;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      color: #E8C990;
    }
  }
  &.board-teacher{
    .list{
      p{
        width: 50%;
        float: left;
        background: #FEFDFC;
        &:nth-child(4n-1), 
        &:nth-child(4n){
          background: #fff;
        }
        &:nth-child(odd){
          border-right: 1px solid #F1F1F4;
        }
      }
    }
  }

  @media (min-width: 987px) {
    margin: 32px 0;
    .header{
      text-align: center;
      height: 60px;
      background-image: url('~@/assets/head/title-back-pc.png');
      img{
        height: 30px;
        max-width: 350px;
      }
    }
    .tabs{
      width: 365px;
      margin: 16px auto;
      height: 36px;
      span{
        line-height: 36px;
        height: 36px;
        font-size: 16px;
        cursor: pointer;
      }
    }
    table{
      td,th{
        font-size: 16px;
        line-height: 24px;
        padding: 8px 16px;
      }
      th{
        line-height: 20px;
      }
    }    
    &.board-industry{
      small{
        margin: 16px 128px;
      }
      table{
        td,th{
          &:first-child{
            padding: 0 8% 0 128px;
          }
        }
      }    
    }    
    &.board-college{
      .list{
        margin: 66px 0 38px;
        p{
          width: 50%;
          float: left;
          background: #FEFDFC;
          &:nth-child(4n-1), 
          &:nth-child(4n){
            background: #fff;
          }
          &:nth-child(odd){
            border-right: 1px solid #F1F1F4;
          }
        }
      }
    }
    &.board-teacher{
      .list{
        margin: 66px 0 38px;
        p{
          width: 25%;
          float: left;
          background: #FEFDFC;
          &:nth-child(8n-3), 
          &:nth-child(8n-2), 
          &:nth-child(8n-1), 
          &:nth-child(8n){
            background: #fff;
          }
          &:nth-child(4n-3), 
          &:nth-child(4n-2), 
          &:nth-child(4n-1){
            border-right: 1px solid #F1F1F4;
          }
        }
      }
    }
    &.board-organization{
      .list{
        margin: 66px 0 38px;
      }
    }
    .list{
      &~.tip{
        top: 84px;
      }
    }
    .tip{
      text-align: center;
      color: #5B280B;
      opacity: 0.45;
    }
    
    .prizes{
      margin: 0 85px 16px;
      .hr{
        margin: 22px 0 38px;
        img{
          height: 19px;
        }
        &:before{
          left: 220px;
        }
        &:after{
          right: 220px;
        }
      }
    }
    .prize{
      padding: 0 12px 16px;
      width: 25%;
      .works{
        cursor: pointer;
      }
    }
    .works-pop{
      .left,.right{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateY(-50%);
        z-index: 10001;
        width: 64px;
        img{
          width: 64px;
        }
      }
      .left{
        margin-left: -356px;
      }
      .right{
        margin-left: 292px;
      }
      .content{
        width: 760px;
      }
      .head{
        height: 80px;
        padding: 12px 0 0;
        font-size: 18px;
        .title{
          height: 31px;
          margin: 0 0 6px;
        }
      }
      .info{
        color: #666;
        i{
          margin-right: 32px;
        }
      }
      .judge{
        .item{
          img{
            width: 120px;
          }
          h6{
            font-size: 16px;
          }
          p{
            font-size: 16px;
            line-height: 26px;
          }
          div{
            font-size: 16px;
            line-height: 26px;
            color: #666666;
            padding: 10px 20px 12px;
            margin: 18px 32px;
          }
        }
      }
      .pic{
        margin: 0 0 30px;
      }
    }
  }
}
</style>
